import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { messageTranslationsStateForContactIdSelector } from '../message-translation-selectors';

import { get } from '../../api/api';

export const loadContactMessageTranslations = (contactId: number) =>
  createGenericDispatcher<MessageTranslation[]>({
    name: 'LOAD_CONTACT_MESSAGE_TRANSLATIONS',
    loadFunction: () => get(`/message-translation?contactId=${contactId}`),
    args: { contactId },
    shouldExecuteSelector: (state: any) =>
      messageTranslationsStateForContactIdSelector(state, contactId),
  });
